import { matchPath } from "react-router";
import get from "lodash/get";

export const getShowUUID = props => {
  const a = matchPath(props.location.pathname, { path: "/shows/:showUUID/sponsor" });
  const b = matchPath(props.location.pathname, { path: "/shows/:showUUID/donations" });
  const c = matchPath(props.location.pathname, { path: "/shows/:showUUID/resubscribe" });
  const d = matchPath(props.location.pathname, {
    path: "/shows/:showUUID/exclusive-content",
  });
  return get(a || b || c || d, "params.showUUID");
};
